export const mockBackendErrors = {
  STATIC_ERROR: 'Static error message',
  DYNAMIC_ERROR: (type?: string) => `Dynamic error: ${type}`,
}
